export default __webpack_public_path__ + "static/media/valdisere-1x.680b770f.webp";